import { gql } from "@apollo/client";

export const getSummaryReportFilters = gql`
    query getSummaryReportDashboardFilters($mill_id: Int!) {
        failure_type(
            where: { _and: [{ corporate_id: { _is_null: true } }, { is_location_specific: { _eq: false } }] }
        ) {
            failure_type_id
            name
            color_code
            is_location_specific
            failure_codes {
                failure_code_id
                name
                primary_code_id
                corporate_id
            }
            default_failure_type_translations {
                failure_type_id
                language {
                    language_id
                    code
                }
                translated_name
            }
        }
        production_line(
            where: {
                _and: [{ mill_id: { _eq: $mill_id } }]
                machine_centers_aggregate: { count: { predicate: { _gt: 0 } } }
            }
        ) {
            production_line_shifts {
                production_line_id
                shift {
                    shift_id
                    name
                }
            }
            production_line_id
            name
            machine_centers {
                machine_center_id
                name
                short_name
                areas {
                    area_id
                    translation {
                        id
                        translation_names {
                            name
                            language_id
                        }
                    }
                    functional_locations(where: { subordinate_to_id: { _is_null: true } }) {
                        functional_location_id
                        translation {
                            id
                            translation_names {
                                name
                                language_id
                            }
                        }
                        location_specific_functional_location_failure_codes(
                            where: { failure_code: { primary_code_id: { _is_null: true } } }
                        ) {
                            functional_location_id
                            failure_code {
                                failure_type {
                                    failure_type_id
                                    name
                                    default_failure_type_translations {
                                        failure_type_id
                                        language {
                                            language_id
                                            name
                                        }
                                        translated_name
                                    }
                                }
                            }
                        }
                    }
                }
                non_location_specific_machine_center_failure_codes(
                    where: { failure_code: { primary_code_id: { _is_null: true } } }
                ) {
                    machine_center_id
                    failure_code {
                        failure_type {
                            failure_type_id
                            name
                            corporate_id
                            default_failure_type_translations {
                                failure_type_id
                                language {
                                    language_id
                                    name
                                }
                                translated_name
                            }
                        }
                    }
                }
            }
        }
    }
`;

export const getSummaryReportDashboardFilters = gql`
    query getSummaryReportDashboardFilters(
        $whereSummaryFilters: event_failure_code_summary_per_mc_bool_exp
        $whereSummaryFunctionalLocationFilters: event_functional_location_summary_per_mc_bool_exp
    ) {
        summary_filters: event_failure_code_summary_per_mc(
            distinct_on: [machine_center_id, shift_id, failure_type_id]
            where: $whereSummaryFilters
        ) {
            machine_center {
                machine_center_id
                name
            }
            shift {
                shift_id
                name
            }
            failure_type {
                failure_type_id
                name
                default_failure_type_translations {
                    failure_type_id
                    language {
                        language_id
                        name
                    }
                    translated_name
                }
            }
        }
        summary_functional_location_filters: event_functional_location_summary_per_mc(
            distinct_on: [functional_location_id, machine_center_id, shift_id, failure_type_id]
            where: $whereSummaryFunctionalLocationFilters
        ) {
            functional_location {
                functional_location_id
                translation {
                    id
                    translation_names {
                        name
                        language_id
                    }
                }
            }
            machine_center {
                machine_center_id
                name
            }
            shift {
                shift_id
                name
            }
            failure_type {
                failure_type_id
                name
                default_failure_type_translations {
                    failure_type_id
                    language {
                        language_id
                        name
                    }
                    translated_name
                }
            }
        }
    }
`;

export const getDetailsFilters = gql`
    query getDetailsFilters($where: event_report_bool_exp, $whereShift: production_line_shift_bool_exp) {
        event_report_filters: event_report(
            distinct_on: [machine_center_id, functional_location_id, failure_code_id, failure_type_id, user_id]
            where: $where
        ) {
            machine_center {
                machine_center_id
                name
                production_line {
                    production_line_id
                    name
                }
            }
            functional_location {
                translation {
                    id
                    translation_names {
                        name
                        language_id
                    }
                }
                functional_location_id
            }
            failure_type {
                name
                failure_type_id
                default_failure_type_translations {
                    failure_type_id
                    language {
                        language_id
                        name
                    }
                    translated_name
                }
            }
            failure_code {
                name
                failure_code_id
                default_failure_code_translations {
                    failure_code_id
                    language {
                        language_id
                        name
                    }
                    translated_name
                }
            }
            user_operator {
                user_id
                first_name
                last_name
            }
        }
        shift_filters: production_line_shift(where: $whereShift, distinct_on: [production_line_id, shift_id]) {
            production_line_id
            shift {
                shift_id
                name
            }
        }
    }
`;

export const getCorporateDashboardFilters = gql`
    query GetCorporateDashboardFilters($where: event_failure_code_summary_per_mc_bool_exp) {
        event_failure_code_summary_per_mc(distinct_on: [machine_center_id], where: $where) {
            machine_center {
                machine_center_id
                name
                production_line {
                    production_line_id
                    name
                    mill {
                        name
                        division {
                            division_id
                            name
                        }
                        region {
                            region_id
                            name
                            division {
                                division_id
                                name
                            }
                        }
                    }
                }
            }
        }
    }
`;
